import { Box, Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AnimatedTypography from '../core/AnimatedTypography';
import HotelGallery from './HotelGallery';
import { FaHotel } from "react-icons/fa6";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

interface HotelDetailsProps {
}


const HotelDetails: React.FC<HotelDetailsProps> = ({ }) => {
    const { t } = useTranslation();

    return (
        <Grid
            sx={{

                // backdropFilter: { xs: "blur(16px)", md: "none" },
                // backgroundColor: "#ffffff63"
            }}
            pb={6}
            px={0}
            pt={1}
            container
            direction={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            width={"100%"}>
            <Box width={"100%"} p={0}>
                <Box display={"flex"} alignItems={"center"} gap={2} mb={{ xs: 4, md: 6 }}>
                    <AnimatedTypography variant='h3' color={"text2.primary"} fontWeight={600}>{"Motel Raduša"}</AnimatedTypography>
                    <WorkspacePremiumIcon color='secondary' sx={{ fontSize: 48 }} />
                </Box>

                <HotelGallery />
            </Box>
        </Grid >
    )
}

export default HotelDetails;